module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/print_feature-e5f8478e5de0d00e9b44b5b3ed4dff9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/print_feature.jpg
// module id = 1594
// module chunks = 0